import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class ModalCheckIcon extends PureComponent {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
  };

  static defaultProps = {
    width: 80,
    height: 80,
  };

  render() {
    const { width, height, className } = this.props;

    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 80 80"
        preserveAspectRatio="xMinYMin"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g fill="none" fillRule="evenodd">
          <circle cx={50} cy={30} r={21} fill="#B0DAF1" />
          <circle
            cx={40}
            cy={40}
            r={28}
            fill="#3F3F3F"
            fillOpacity={0}
            stroke="#000"
            strokeWidth={2}
          />
          <path
            d="M54.9 30.1L35.1 49.9m-.2 0L25 40"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
          />
        </g>
      </svg>
    );
  }
}

export default ModalCheckIcon;
